import axios from "axios";

export const getAllPurchaseRequest = (obj, search = "") => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/get-all-purchaseRequest-updated?search=${search}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching packages:", err.response || err);
      throw err;
    });
};
export const getPurchaseRequestById = (obj, id) => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/get-purchaseRequest/` +
        id,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching packages:", err.response || err);
      throw err;
    });
};
export const getPharmacyVerifiedData = (obj, prId) => {
  return axios
    .get(`${process.env.REACT_APP_NOT_SECRET_CODE}/refill-request/${prId}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching packages:", err.response || err);
      throw err;
    });
};
export const geAllPurchaseRequestData = (obj, id) => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/check-purchase-request-period/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching packages:", err.response || err);
      throw err;
    });
};
export const getAllReleaseStockByMediId = (obj, id) => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/check-released-stock/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching packages:", err.response || err);
      throw err;
    });
};

export const createPurchaseRequest = (obj, tagPayload) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/multi-store/create-purchaseRequest";
  return axios

    .post(url, tagPayload, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const CreateNewPurchaseRequest = (obj, tagPayload) => {
  let url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/multi-store/create-purchaseRequest-updated";
  return axios

    .post(url, tagPayload, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res;
    });
};
export const deletePurchaseRequest = (id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/multi-store/delete-purchaseRequest/" +
        id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updatePurchaseRequest = (id, obj, tagPayload) => {
  return axios
    .put(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/edit-purchaseRequest/${id}`,
      tagPayload,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res)
    .catch((err) => {
      console.error("Update Purchase Request failed", err);
    });
};

export const statusUpdate = (id, payload, obj) => {
  return axios
    .put(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/purchaseRequest/status-update/${id}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res)
    .catch((err) => {
      console.error("Update Purchase Request failed", err);
    });
};
export const updateStatusChange = (obj, payload) => {
  return axios.post(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/update-status`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  );
};
export const updateStatus = (obj, payload) => {
  return axios.post(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/completePurchaseRequest`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  );
};
export const getStoreRelatedById = (
  obj,
  store,
  title = "",
  item_code = "",
  generic_name = "",
  page = 1,
  store_id = "",
  is_show_all_medicine = 1,
) => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/get-inventoryRelatedStore/` +
        `?store=${store}&title=${title}&item_code=${item_code}` +
        `&generic_name=${generic_name}&page=${page}` +
        `&store_id=${store_id}&is_show_all_medicine=${is_show_all_medicine}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
    });
};

export const updateStatusChanges = (obj, payload) => {
  return axios.post(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/update-status`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  );
};
export const PurchaseRequestMedicationCheck = (obj, mediId) => {
  return axios.post(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/multi-store/medication-check`,
    mediId,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    },
  );
};
